// src/services/api.js
import axios from "axios";

const api = axios.create({
  // Use the environment variable, with a fallback for local development
  baseURL:
    process.env.REACT_APP_API_BASE_URL ||
    "https://chafadi-backend.onrender.com/api/",
});
// Optional: Add a request interceptor to attach token if exists
api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("chafadi-token") ||
      localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
